/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Button,
  Divider,
  Flex,
  Form,
  FormInstance,
  GetProp,
  Input,
  Modal,
  Typography,
} from 'antd';
import { maxSize } from 'constants/screenSize';
import { useLanguage } from 'hooks/Language/useLanguage';
import { PenLine } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import urls from 'routes/urls';

const { Text, Title } = Typography;

interface PINModalProps {
  open: boolean;
  onClose: () => void;
  isLoading: boolean;
  onValuesChange: GetProp<typeof Input.OTP, 'onChange'>;
  onHandleConfirm: () => void;
  form?: FormInstance<any>;
  pin: string;
}

const PINModal = ({
  open,
  onClose,
  onValuesChange,
  isLoading,
  onHandleConfirm,
  form,
  pin,
}: PINModalProps) => {
  const { translate } = useLanguage();
  const navigate = useNavigate();

  return (
    <Modal
      title={
        <Flex vertical align="center">
          <Title level={4}>{translate('Enter PIN to confirm')}</Title>
          <Text type="secondary">
            {translate(
              'To view your account balance, please enter your 6-digit PIN',
            )}
          </Text>
        </Flex>
      }
      open={open}
      closeIcon={false}
      onCancel={!isLoading ? onClose : undefined}
      footer={[]}
    >
      <Form
        layout="vertical"
        form={form}
        className="xlarge-margin-top"
      >
        <Flex align="center" vertical>
          <Form.Item
            className="large-margin-bottom"
            style={{ width: maxSize }}
          >
            <Input.OTP
              length={6}
              type="password"
              size="large"
              style={{ width: '100%' }}
              onChange={onValuesChange}
              value={pin}
              mask
            />
          </Form.Item>
        </Flex>
        <Divider />
        <Form.Item className="small-margin-bottom">
          <Flex justify="space-between">
            <Button
              variant="filled"
              color="default"
              icon={<PenLine strokeWidth={1} />}
              onClick={() =>
                navigate(urls.userProfile, {
                  state: {
                    tabId: '2',
                  },
                })
              }
            >
              {translate('Change PIN')}
            </Button>
            <Flex gap="middle">
              <Button
                variant="filled"
                color="danger"
                type="primary"
                onClick={onClose}
              >
                {translate('Close')}
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                onClick={onHandleConfirm}
                loading={isLoading}
                disabled={isLoading}
              >
                {translate('Confirm')}
              </Button>
            </Flex>
          </Flex>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PINModal;
